import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ConfigureAmplifyClientSide from './ConfigureAmplify';

import * as Sentry from '@sentry/react';
import SnackbarProvider from './components/snackbar/SnackbarProvider';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from './utils/context/useAuthContext';
import { UtilsProvider } from './utils/context/useUtilsContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

if (process.env.BUILD_ENV === 'main') {
  Sentry.init({
    dsn: 'https://c316a3dd88056002cc0330c7d6360f70@o4508568685576192.ingest.us.sentry.io/4508568687673344',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: false,
      }),
    ],

    environment: 'main',

    tracesSampleRate: 1.0,

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
} else {
  console.log('Sentry is disabled in development mode.');
}

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <BrowserRouter>
        <AuthProvider>
          <UtilsProvider>
            <SnackbarProvider>
              <ThemeProvider theme={theme}>
                <ConfigureAmplifyClientSide />
                <QueryClientProvider client={queryClient}>
                  <App />
                  <ReactQueryDevtools initialIsOpen={false} />
                </QueryClientProvider>
              </ThemeProvider>
            </SnackbarProvider>
          </UtilsProvider>
        </AuthProvider>
      </BrowserRouter>
    </LocalizationProvider>
  </React.StrictMode>,
);

reportWebVitals();
